import React, { useState, useEffect } from "react";
import { imageurl, imgCheck } from "../Utils/fn";
import { CircularProgress } from "@mui/material";
import img from "./../../assets/product-placeholder.png"
import { capitalizeFirst, currencyseperator } from "../Utils/functions";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Ratings from "../Components/ratingcomp";

const Productcard = ({ product, productkey, showquantity, alignmiddle, showoffer, showrating }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const webSettings = useSelector((state) => state.webSettings.data);
    const pathname = location?.pathname
    const [thumbnail, setThumbnail] = useState(null);





    useEffect(() => {
        Array.isArray(product.src) && imgCheck(imageurl(product.src[0]), img).then((src) => setThumbnail(src));
    }, [product]);

    function viewProduct() {
        navigate('/product/' + product.itemURL, {
            state: { product: product }
        });
    }

    const percentage = (number) => {
        const fraction = Math.round((number / 500) * 100)
        return fraction > 100 ? 100 : fraction;
    }


    const savingpercentage = product?.amount_value ? Math.round(((parseFloat(product.amount_value) - parseFloat(product.promotion_price)) / parseInt(product.amount_value)) * 100) : 0


    return (
        <div className="productcard" key={productkey} onClick={() => viewProduct()}>
            {/* {(pathname === '/todays-deals' || showquantity) && <>
                <div className='offerbanner'>save<br />{savingpercentage == 'NaN' ? 0 : savingpercentage}% </div>
            </>} */}
            {(pathname === '/todays-deals' || showoffer) && savingpercentage !== 100 &&
                <>
                    <div className='offerbanner2'>-{savingpercentage == 'NaN' ? 0 : savingpercentage}% </div>
                </>}
            <p align="middle" className='wrapimage' >
                {thumbnail && <img src={thumbnail} className='singleproductcardimage' />}
                {thumbnail == null && <CircularProgress size={14} />}
            </p>
            <div className="productname" style={{ textAlign: alignmiddle && "center" }}>{capitalizeFirst(product.item_name?.substring(0, 20))}</div>
            <div className='wrapprice' style={{ alignItems: alignmiddle && "center", justifyContent: alignmiddle && "center" }}>
                <div className='currencytext'>{webSettings.CURRENCY}</div>
                {product.promotion_price > 0 ?
                    <div className='pricetext'>{currencyseperator(product.promotion_price)} </div> :
                    <div className='pricetext'>{currencyseperator(parseFloat(product.price)?.toFixed(2))}</div>}
            </div>
            {showrating && <Ratings product={product} starsize={12} />}
            {
                (pathname === '/todays-deals' || showquantity) && <>
                    {webSettings.ITEMS_OUTOFSTOCK_LABEL === 'Y' && <div className='unitslefttext'>{product.closing > 0 ? `${product.closing} units left` : <text className='outofstocktext'>Out of stock</text>}</div>}
                </>
            }
            {
                (pathname === '/todays-deals' || showquantity) && <>
                    {webSettings.ITEMS_OUTOFSTOCK_LABEL === 'Y' &&
                        <div className="stockprogress">
                            <div className="starslideractive" style={{
                                width: percentage(product.closing),
                                backgroundColor: percentage(product.closing) > 20 ? "orange" : "red"
                            }} />
                            <div className="starsliderinactive" />
                        </div>
                    }
                </>
            }
        </div >)
}

export default Productcard